import { Injectable } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { DocumentTypeActions } from 'src/app/root-store/doc-admin-store/actions';
import { MetadataNSwagMigrationService } from '../../api/migration/metadata-nswag-migration.service';
import {
    getMetadataConfiguration,
    getMetadataConfigurationFailure,
    getMetadataConfigurationSuccess,
    resetMetadataConfiguration
} from '../actions/metadata-configuration.actions';
import { selectMetadataConfiguration } from '../selectors/metadata-configuration.selectors';

@Injectable()
export class MetadataConfigurationEffects {
    constructor(
        private readonly _actions$: Actions,
        private readonly _metadataService: MetadataNSwagMigrationService,
        private readonly _store: Store
    ) {}

    getMetadataConfiguration$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(getMetadataConfiguration),
            concatLatestFrom(() => this._store.select(selectMetadataConfiguration)),
            switchMap(([action, currentConfig]) =>
                action.documentTypeId === currentConfig?.documentTypeId
                    ? of(getMetadataConfigurationSuccess({ metadataConfiguration: currentConfig }))
                    : this._metadataService.getMetadataConfiguration(action.documentTypeId).pipe(
                          map((result) => getMetadataConfigurationSuccess({ metadataConfiguration: result })),
                          catchError((result) => of(getMetadataConfigurationFailure({ error: result.message })))
                      )
            )
        );
    });

    resetMetadataConfiguration$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(
                DocumentTypeActions.DocumentTypesDetail.uploadDocumentSuccess,
                DocumentTypeActions.DocumentTypesDetail.updateDocumentSuccess,
                DocumentTypeActions.DocumentTypesDetail.uploadDocumentFileSuccess
            ),
            map(() => resetMetadataConfiguration())
        );
    });
}
